import { WarningAmber as WarningAmberIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { StatusLabel } from 'components';
import { TranslationNamespace } from 'i18n';
import { Trader } from 'types';
import { formatUtils, traderUtils } from 'utils';

export const TraderStatus = ({ trader }: { trader: Trader }) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.traders',
  });

  return (
    <div className="tw-flex tw-items-center">
      <StatusLabel
        label={traderUtils.getWorkStatusLabel(trader.workStatus)}
        status={trader.workStatus}
      />
      {trader.unableTakeOrders && (
        <Tooltip
          title={
            trader.unableTakeOrdersUntilAt
              ? t('unable_take_orders_trader_time', {
                  date: formatUtils.formatDate(trader.unableTakeOrdersUntilAt),
                })
              : t('unable_take_orders_trader')
          }
        >
          <WarningAmberIcon color="error" />
        </Tooltip>
      )}
    </div>
  );
};
